export const FREQUENCY_OPTIONS = (t) => [
    {
        label: t('ai_tracking.add_keyword.frequency_options.just_once'),
        value: 'just_once',
    },
    {
        label: t('ai_tracking.add_keyword.frequency_options.daily'),
        value: 'daily',
    },
    {
        label: t('ai_tracking.add_keyword.frequency_options.weekly'),
        value: 'weekly',
    },
];

// Bulk changes cannot switch prompts to just_once: it would have to run them immediately, and
// would let a prompt be cycled daily -> just_once -> daily to run over and over.
export const BULK_FREQUENCY_OPTIONS = (t) =>
    FREQUENCY_OPTIONS(t).filter((option) => option.value !== 'just_once');

export const DEVICE_OPTIONS = (t) => [
    { value: 'mobile', label: t('ai_tracking.add_keyword.device_options.mobile') },
    { value: 'desktop', label: t('ai_tracking.add_keyword.device_options.desktop') },
    { value: 'tablet', label: t('ai_tracking.add_keyword.device_options.tablet') },
];

export const PLATFORM_OPTIONS = [
    {
        value: 'google_ai_overview',
        label: (
            <div>
                Google AI Overview <span>(incl. Google Search)</span>
            </div>
        ),
    },
    { value: 'google_ai_mode', label: 'Google AI Mode' },
    { value: 'chat_gpt', label: 'ChatGPT' },
    { value: 'gemini', label: 'Gemini' },
    { value: 'perplexity', label: 'Perplexity' },
    // { value: 'grok', label: 'Grok' },
];
